var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    display: "block",
    className: "vkuiIcon vkuiIcon--24 vkuiIcon--w-24 vkuiIcon--h-24 vkuiIcon--delete_outline_24",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    style: {
      width: 24,
      height: 24
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    id: "delete_outline_24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.556 8.102a.9.9 0 0 1 .842.954l-.5 8a.9.9 0 0 1-1.796-.112l.5-8a.9.9 0 0 1 .954-.842m-5.112 0a.9.9 0 0 0-.842.954l.5 8a.9.9 0 1 0 1.796-.112l-.5-8a.9.9 0 0 0-.954-.842",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 4.1a.9.9 0 1 0 0 1.8h1.18l1.155 12.316c.045.484.084.898.143 1.237.062.359.157.704.351 1.03a2.9 2.9 0 0 0 1.249 1.137c.342.162.695.225 1.057.253.344.027.76.027 1.246.027h5.238c.486 0 .902 0 1.246-.027.362-.028.715-.09 1.057-.253a2.9 2.9 0 0 0 1.249-1.137c.194-.326.289-.671.35-1.03.06-.34.099-.753.144-1.237L19.82 5.9H21a.9.9 0 1 0 0-1.8h-5.204a3.901 3.901 0 0 0-7.592 0zm4.124 13.915c.05.526.082.869.128 1.13.043.252.087.356.124.417a1.1 1.1 0 0 0 .474.432c.064.03.172.065.426.085.265.02.61.021 1.138.021h5.172c.528 0 .873 0 1.138-.021.254-.02.362-.055.426-.085a1.1 1.1 0 0 0 .474-.432c.037-.06.08-.166.124-.416.046-.262.079-.605.128-1.131L18.012 5.9H5.988zM12 2.9a2.1 2.1 0 0 0-1.898 1.2h3.796A2.1 2.1 0 0 0 12 2.9",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#delete_outline_24",
    style: {
      fill: "currentcolor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a65a182c893a32cff9d9440a05f462d2.svg";
export { ForwardRef as ReactComponent };